import React from 'react';
import PropTypes from 'prop-types';

export default function AuthorAvatar({onClick, image, size}) {
  require('./AuthorAvatar.scss');

  return (
    <img className={["author-avatar", size].join(' ').trim()} onClick={onClick} src={image ? `/${image}` : "/img/default-profile.svg"} />
  );
}

AuthorAvatar.propTypes = {
  onClick: PropTypes.func,
  image: PropTypes.string,
  size: PropTypes.string
}


// WEBPACK FOOTER //
// ./modules/Common/components/AuthorAvatar.js